import { Badge } from 'antd'
import { useGate, useUnit } from 'effector-react'

import {
  $feedbacksActiveCount,
  FeedbacksActiveCountGate,
} from '../model/feedbacks-active-count.model'

export function FeedbacksActiveCount() {
  useGate(FeedbacksActiveCountGate)
  const feedbacksActiveCount = useUnit($feedbacksActiveCount)
  return feedbacksActiveCount > 0 ? (
    <Badge color="purple" count={feedbacksActiveCount} />
  ) : null
}
